import React, { useState, useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import './index.css';
import GlobalState from "../../stores/GlobalState";
import Pool from "../autorize/UserPool";
import Domen from "../../stores/Domen";
import lang from "../../lang";
import Loading from '../common/loading';

const CHUNK_SIZE_FALLBACK = 5 * 1024 * 1024;
const MAX_UPLOAD_RETRIES = 3;
const UPLOAD_ACTIVITY_INTERVAL = 30 * 1000;
let tokenRefreshPromise = null;


const Sidebar = observer(() => {
    const [langmenu] = useState(localStorage.getItem("lang_site") || "en");
    const [langv] = useState(langmenu === "de" ? lang.de : lang.en);

    const inputRef = useRef(null);

    const [files, setFiles] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(8);
    const [loading, setLoading] = useState(false);
    const [height, setHeight] = useState(window.innerHeight);
    const [isDrag, setIsDrag] = useState(false);
    const [showUploadPopup, setShowUploadPopup] = useState(false);
    const [uploadItems, setUploadItems] = useState([]);
    const [activeId, setActiveId] = useState(null);
    const ref = useRef(null);
    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setActiveId(null);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
    const handleClick = (id) => {
        setActiveId(activeId === id ? null : id);
    };
    useEffect(() => {
        const count = Math.max(1, Math.trunc((window.innerHeight * 1 - 200) / 75));

        setLimit(count);
        loadFiles(1, count);
    }, []);

    // const getAuthHeaders = (json = true) => {
    //     var token = localStorage.getItem("token");
    //     localStorage.setItem("countactivetime", Date.now());

    //     const headers = {
    //         'Authorization': token,
    //     };

    //     if (json) {
    //         headers['Content-Type'] = 'application/json';
    //     }

    //     return headers;
    // };





    const logoutAndRedirect = () => {
        const user = Pool.getCurrentUser();

        if (user) {
            user.signOut();
        }

        localStorage.removeItem("token");
        localStorage.setItem(
            "countactivetime",
            Date.now().toString()
        );

        if (
            !window.location.pathname.includes("/login") &&
            !window.location.pathname.includes("/forgotpassword") &&
            !window.location.pathname.includes("/newpassword")
        ) {
            window.location.href = "/login";
        }
    };

    const getFreshAccessToken = async (forceRefresh = false) => {
        /*
        * Якщо refresh уже виконується іншим паралельним запитом,
        * усі інші запити чекають той самий Promise.
        */
        if (tokenRefreshPromise) {
            return tokenRefreshPromise;
        }

        tokenRefreshPromise = new Promise((resolve, reject) => {
            const user = Pool.getCurrentUser();

            if (!user) {
                reject(new Error("User is not authenticated"));
                return;
            }

            user.getSession((sessionError, session) => {
                if (sessionError || !session) {
                    reject(
                        sessionError ||
                        new Error("Could not get Cognito session")
                    );
                    return;
                }

                const saveAndResolveToken = (actualSession) => {
                    if (
                        !actualSession ||
                        !actualSession.isValid()
                    ) {
                        reject(new Error("Cognito session is invalid"));
                        return;
                    }

                    const accessToken = actualSession
                        .getAccessToken()
                        .getJwtToken();

                    localStorage.setItem(
                        "token",
                        accessToken
                    );

                    resolve(accessToken);
                };

                /*
                * Звичайний запит.
                * getSession автоматично використовує refresh token,
                * якщо Access Token уже протух.
                */
                if (!forceRefresh) {
                    saveAndResolveToken(session);
                    return;
                }

                /*
                * Після 401 примусово просимо нову сесію.
                */
                const refreshToken = session.getRefreshToken();

                if (!refreshToken) {
                    reject(new Error("Refresh token is missing"));
                    return;
                }

                user.refreshSession(
                    refreshToken,
                    (refreshError, refreshedSession) => {
                        if (
                            refreshError ||
                            !refreshedSession
                        ) {
                            reject(
                                refreshError ||
                                new Error(
                                    "Could not refresh Cognito session"
                                )
                            );
                            return;
                        }

                        saveAndResolveToken(refreshedSession);
                    }
                );
            });
        }).finally(() => {
            tokenRefreshPromise = null;
        });

        return tokenRefreshPromise;
    };

const buildAuthHeaders = (
    token,
    json = true,
    additionalHeaders = {}
) => {
    const headers = {
        ...additionalHeaders,

        /*
         * Залишаємо формат таким, як у тебе був.
         * Якщо бекенд очікує Bearer, дивись примітку нижче.
         */
        Authorization: token
    };

    if (json) {
        headers["Content-Type"] = "application/json";
    }

    return headers;
};

const authorizedFetch = async (
    url,
    options = {},
    json = true
) => {
    localStorage.setItem(
        "countactivetime",
        Date.now().toString()
    );

    /*
     * Перед кожним бекенд-запитом отримуємо
     * актуальну Cognito-сесію.
     */
    let token = await getFreshAccessToken(false);

    const makeRequest = (accessToken) => {
        return fetch(url, {
            ...options,
            headers: buildAuthHeaders(
                accessToken,
                json,
                options.headers || {}
            )
        });
    };

    let response = await makeRequest(token);

    /*
     * Якщо бекенд усе-таки повернув 401:
     * 1. примусово оновлюємо токен;
     * 2. повторюємо конкретний запит один раз.
     */
    if (response.status === 401) {
        console.warn(
            "Request returned 401. Refreshing Cognito token..."
        );

        try {
            token = await getFreshAccessToken(true);
            response = await makeRequest(token);
        } catch (refreshError) {
            console.error(
                "Cognito token refresh failed:",
                refreshError
            );

            logoutAndRedirect();
            throw refreshError;
        }
    }

    /*
     * Якщо навіть після refresh сервер повернув 401,
     * сесія вже реально непридатна.
     */
    if (response.status === 401) {
        logoutAndRedirect();

        throw new Error(
            "Unauthorized after Cognito token refresh"
        );
    }

    return response;
};
    const loadFiles = async (nextPage = page, nextLimit = limit) => {
        try {
            setLoading(true);

            const response = await authorizedFetch(
                Domen.url +
                `raw-files/?page=${nextPage}` +
                `&limit=${nextLimit}` +
                `&sort=created_at:desc`,
                {
                    method: "GET"
                }
            );

            if (response.status === 200) {
                const data = await response.json();

                setFiles(data.items || []);
                setTotal(data.total || 0);
                setPage(nextPage);
            } else {
                console.log("raw files load error");
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    const openFileDialog = () => {
        inputRef.current?.click();
    };

    const onInputChange = (e) => {
        const selected = Array.from(e.target.files || []);

        if (selected.length > 0) {
            handleFiles(selected);
        }

        e.target.value = "";
    };

    const onDragOver = (e) => {
        e.preventDefault();
        setIsDrag(true);
    };

    const onDragLeave = (e) => {
        e.preventDefault();

        if (!e.currentTarget.contains(e.relatedTarget)) {
            setIsDrag(false);
        }
    };

    const onDrop = (e) => {
        e.preventDefault();
        setIsDrag(false);

        const dropped = Array.from(e.dataTransfer.files || []);

        if (dropped.length > 0) {
            handleFiles(dropped);
        }
    };

    const handleFiles = async (selectedFiles) => {
        const pack = selectedFiles.slice(0, 10);

        if (!pack.length) {
            return;
        }

        /*
        * Upload вважаємо активністю користувача.
        * Одразу скидаємо inactivity-таймер.
        */
        localStorage.setItem(
            "countactivetime",
            Date.now().toString()
        );

        /*
        * Поки файли завантажуються, кожні 30 секунд
        * підтримуємо inactivity-таймер активним.
        *
        * Навіть якщо один PUT-запит вантажиться дуже довго,
        * користувача не розлогінить.
        */
        const uploadActivityInterval = window.setInterval(() => {
            localStorage.setItem(
                "countactivetime",
                Date.now().toString()
            );
        }, UPLOAD_ACTIVITY_INTERVAL);

        const newPopupItems = pack.map((file) => ({
            localId: `${file.name}-${file.size}-${Date.now()}-${Math.random()}`,
            name: file.name,
            size: file.size,
            status: "uploading",

            progress: 0,
            uploadedBytes: 0,

            backendId: null
        }));

        setUploadItems((prev) => [...newPopupItems, ...prev]);
        setShowUploadPopup(true);

        try {
            const initResponse = await authorizedFetch(
                Domen.url + `raw-files/upload/init`,
                {
                    method: "POST",
                    body: JSON.stringify({
                        files: pack.map((file) => ({
                            name: file.name,
                            fileType:
                                file.type ||
                                "application/octet-stream",
                            fileSize: file.size
                        }))
                    })
                }
            );

            if (initResponse.status !== 201 && initResponse.status !== 200) {
                throw new Error("Upload init failed");
            }

            const initData = await initResponse.json();
            const initFiles = initData.files || [];

            const uploadResults = await Promise.all(
            pack.map((file, index) => {
                const uploadInfo = initFiles[index];
                const popupItem = newPopupItems[index];

                if (!uploadInfo || !uploadInfo.fileId) {
                    updateUploadItem(popupItem.localId, { status: "failed" });
                    return false;
                }

                updateUploadItem(popupItem.localId, {
                    backendId: uploadInfo.fileId
                });

                return uploadSingleFile(file, uploadInfo, popupItem.localId);
            })
        );

       
            setTimeout(() => {
                loadFiles(1, limit);
            }, 1000);

            // setTimeout(() => {
            //     loadFiles(1, limit);
            // }, 60000);
       
        } catch (e) {
            console.error("Files upload failed:", e);

            newPopupItems.forEach((item) => {
                updateUploadItem(item.localId, {
                    status: "failed",
                    error: e?.message || "File upload failed"
                });
            });
        } finally {
            /*
            * Зупиняємо upload keep-alive тільки після того,
            * як усі файли завершилися success або failed.
            */
            window.clearInterval(uploadActivityInterval);

            /*
            * Від моменту завершення upload починаються
            * нові повні 15 хвилин до автоматичного logout.
            */

            
            localStorage.setItem(
                "countactivetime",
                Date.now().toString()
            );
        }
    };

    const uploadChunkViaXHR = ({
        presignedUrl,
        chunk,
        file,
        start,
        end,
        localId
    }) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.open('PUT', presignedUrl, true);

            xhr.setRequestHeader(
                'Content-Type',
                file.type || 'application/octet-stream'
            );

            // xhr.setRequestHeader(
            //     'Content-Range',
            //     `bytes ${start}-${end - 1}/${file.size}`
            // );

            /*
            * event.loaded показує, скільки байтів поточного чанка
            * браузер уже відправив.
            *
            * start містить кількість байтів попередніх чанків.
            */
            xhr.upload.onprogress = (event) => {
                if (!event.lengthComputable) {
                    return;
                }

                const uploadedBytes = Math.min(
                    file.size,
                    start + event.loaded
                );

                const progress = Math.min(
                    100,
                    Math.max(
                        0,
                        Math.round(
                            (uploadedBytes / file.size) * 100
                        )
                    )
                );

                updateUploadItem(localId, {
                    uploadedBytes,
                    progress
                });
            };

            /*
            * Сюди потрапляють відповіді, які браузер
            * дозволив прочитати.
            */
            xhr.onload = () => {
                resolve({
                    status: xhr.status,
                    responseText: xhr.responseText
                });
            };

            /*
            * Сюди також може потрапити 499/503,
            * прихований браузером через CORS.
            */
            xhr.onerror = () => {
                reject(
                    new Error(
                        `Chunk request failed or was blocked by CORS. ` +
                        `Status: ${xhr.status || 'unknown'}`
                    )
                );
            };

            xhr.onabort = () => {
                reject(
                    new Error('Chunk upload aborted')
                );
            };

            xhr.ontimeout = () => {
                reject(
                    new Error('Chunk upload timeout')
                );
            };

            xhr.send(chunk);
        });
    };
    
    // const uploadChunkWithRetry = async (
    //     presignedUrl,
    //     chunk,
    //     file,
    //     start,
    //     end,
    //     partNumber
    // ) => {
    //     let lastError = null;

    //     for (let attempt = 1; attempt <= MAX_UPLOAD_RETRIES; attempt++) {
    //         try {
    //             console.log(
    //                 `Uploading "${file.name}", chunk ${partNumber}, ` +
    //                 `attempt ${attempt}/${MAX_UPLOAD_RETRIES}`
    //             );

    //             const response = await fetch(presignedUrl, {
    //                 method: 'PUT',
    //                 headers: {
    //                     'Content-Type': file.type || 'application/octet-stream',
    //                     'Content-Range': `bytes ${start}-${end - 1}/${file.size}`
    //                 },
    //                 body: chunk
    //             });

    //             // 200/201 для завершального запиту,
    //             // 308 для прийнятого проміжного чанка.
    //             if (response.ok || response.status === 308) {
    //                 console.log(
    //                     `File "${file.name}", chunk ${partNumber} accepted. ` +
    //                     `Status: ${response.status}`
    //                 );

    //                 return true;
    //             }

    //             lastError = new Error(
    //                 `Chunk ${partNumber} failed with status ${response.status}. ` +
    //                 `Attempt ${attempt}/${MAX_UPLOAD_RETRIES}`
    //             );

    //             console.warn(lastError.message);
    //         } catch (error) {
    //             /*
    //             * У твоєму випадку GCS для 499/503 не повертає
    //             * Access-Control-Allow-Origin, тому браузер приховує
    //             * справжній статус і кидає TypeError: Failed to fetch.
    //             *
    //             * Тому TypeError теж вважаємо невдалою спробою
    //             * і повторюємо поточний чанк.
    //             */
    //             lastError = error;

    //             console.warn(
    //                 `Chunk ${partNumber} request failed or was blocked by CORS. ` +
    //                 `Attempt ${attempt}/${MAX_UPLOAD_RETRIES}`,
    //                 error
    //             );
    //         }

    //         if (attempt < MAX_UPLOAD_RETRIES) {
    //             const retryDelay = 1000 * attempt;

    //             console.log(
    //                 `Retrying chunk ${partNumber} in ${retryDelay} ms`
    //             );

    //             await new Promise((resolve) => {
    //                 setTimeout(resolve, retryDelay);
    //             });
    //         }
    //     }

    //     throw new Error(
    //         `Chunk ${partNumber} of "${file.name}" failed after ` +
    //         `${MAX_UPLOAD_RETRIES} attempts. ` +
    //         `${lastError?.message || ''}`
    //     );
    // };
    
    const uploadChunkWithRetry = async (
        presignedUrl,
        chunk,
        file,
        start,
        end,
        partNumber,
        localId
    ) => {
        let lastError = null;

        for (
            let attempt = 1;
            attempt <= MAX_UPLOAD_RETRIES;
            attempt++
        ) {
            try {
                console.log(
                    `Uploading "${file.name}", chunk ${partNumber}, ` +
                    `attempt ${attempt}/${MAX_UPLOAD_RETRIES}`
                );

                /*
                * Перед retry повертаємо прогрес на початок
                * поточного чанка.
                *
                * Наприклад, попередні чанки дали 40%.
                * Поточний дійшов до 50%, але впав.
                * Retry знову починається з 40%.
                */
                if (attempt > 1) {
                    const progressBeforeChunk = Math.min(
                        100,
                        Math.round(
                            (start / file.size) * 100
                        )
                    );

                    updateUploadItem(localId, {
                        uploadedBytes: start,
                        progress: progressBeforeChunk
                    });
                }

                const response = await uploadChunkViaXHR({
                    presignedUrl,
                    chunk,
                    file,
                    start,
                    end,
                    localId
                });

                /*
                * 200/201 та інші 2xx означають успіх.
                * 308 означає, що проміжний чанк прийнятий.
                */
                if (
                    (
                        response.status >= 200 &&
                        response.status < 300
                    ) ||
                    response.status === 308
                ) {
                    /*
                    * Фіксуємо точну межу чанка.
                    * Це прибирає похибку останнього progress event.
                    */
                    const progress = Math.min(
                        100,
                        Math.round(
                            (end / file.size) * 100
                        )
                    );

                    updateUploadItem(localId, {
                        uploadedBytes: end,
                        progress
                    });

                    console.log(
                        `File "${file.name}", chunk ${partNumber} accepted. ` +
                        `Status: ${response.status}`
                    );

                    return true;
                }

                lastError = new Error(
                    `Chunk ${partNumber} failed with status ` +
                    `${response.status}. Attempt ` +
                    `${attempt}/${MAX_UPLOAD_RETRIES}`
                );

                console.warn(lastError.message);
            } catch (error) {
                lastError = error;

                console.warn(
                    `Chunk ${partNumber} request failed. ` +
                    `Attempt ${attempt}/${MAX_UPLOAD_RETRIES}`,
                    error
                );
            }

            if (attempt < MAX_UPLOAD_RETRIES) {
                const retryDelay = 3000 * attempt;
                const retryDelaySeconds = retryDelay / 1000;

                console.log(
                    `Chunk ${partNumber} failed. ` +
                    `Retry ${attempt + 1}/${MAX_UPLOAD_RETRIES} ` +
                    `will start in ${retryDelaySeconds} seconds`
                );

                await new Promise((resolve) => {
                    setTimeout(resolve, retryDelay);
                });
            }
        }

        throw new Error(
            `Chunk ${partNumber} of "${file.name}" failed after ` +
            `${MAX_UPLOAD_RETRIES} attempts. ` +
            `${lastError?.message || ''}`
        );
    };
    const uploadSingleFile = async (file, uploadInfo, localId) => {
        const fileId = uploadInfo.fileId;
        const chunkSize = uploadInfo.chunkSize || CHUNK_SIZE_FALLBACK;
        const totalParts = uploadInfo.totalParts || Math.ceil(file.size / chunkSize);

        try {
            for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
                const start = (partNumber - 1) * chunkSize;
                const end = Math.min(start + chunkSize, file.size);
                const chunk = file.slice(start, end);

                const partResponse = await authorizedFetch(
                    Domen.url +
                    `raw-files/upload/${fileId}/parts`,
                    {
                        method: "POST",
                        body: JSON.stringify({
                            partNumber
                        })
                    }
                );

                if (partResponse.status !== 200) {
                    throw new Error("Get presigned url failed");
                }

                const partData = await partResponse.json();

                await uploadChunkWithRetry(
                    partData.presignedUrl,
                    chunk,
                    file,
                    start,
                    end,
                    partNumber,
                    localId
                );
            }

            const completeResponse = await authorizedFetch(
                Domen.url +
                `raw-files/upload/${fileId}/complete`,
                {
                    method: "POST"
                },
                false
            );

            if (completeResponse.status !== 200) {
                throw new Error("Complete upload failed");
            }

            const completeData = await completeResponse.json();

            if (completeData.success !== true) {
                throw new Error("Complete success false");
            }

            updateUploadItem(localId, {
                status: "success",
                progress: 100,
                uploadedBytes: file.size,
                error: null
            });

            return true;
        } catch (e) {
            console.error(
                `File "${file.name}" upload failed:`,
                e
            );

            updateUploadItem(localId, {
                status: "failed",
                error: e?.message || "File upload failed"
            });

            return false;
        }
    };

    const updateUploadItem = (localId, patch) => {
        setUploadItems((prev) =>
            prev.map((item) =>
                item.localId === localId ? { ...item, ...patch } : item
            )
        );
    };

    const deleteFile = async (fileId) => {
        try {
            const response = await authorizedFetch(
                Domen.url + `raw-files/${fileId}`,
                {
                    method: "DELETE"
                },
                false
            );

            if (response.status !== 200) {
                console.log("delete raw file error");
                return;
            }

            /*
            * Якщо на поточній сторінці був останній файл
            * і це не перша сторінка, після видалення
            * переходимо на попередню.
            */
            const isLastFileOnPage = files.length === 1;
            const nextPage = isLastFileOnPage && page > 1
                ? page - 1
                : page;

            setActiveId(null);

            await loadFiles(nextPage, limit);
        } catch (e) {
            console.log(e);
        }
    };

    const formatSize = (size) => {
        if (!size) return "0 mb";

        const mb = size / 1024 / 1024;

        if (mb < 1) {
            return `${(size / 1024).toFixed(1)} kb`;
        }

        return `${mb.toFixed(1)} mb`;
    };

    const formatDate = (date) => {
        if (!date) return "";

        const d = new Date(date);

        if (Number.isNaN(d.getTime())) {
            return date;
        }

        return d.toLocaleDateString("en-GB").replaceAll("/", ".");
    };

    const getTypeFromFile = (file) => {
        if (file.fileType) {
            const parts = file.fileType.split("/");
            return parts[1] || parts[0];
        }

        if (file.name && file.name.includes(".")) {
            return file.name.split(".").pop();
        }

        return "-";
    };

    const getStatusText = (status) => {
        if (status === "failed") return "Failed";
        if (status === "in_progress") return "In progress";
        if (status === "completed") return "Success";

        return status || "Success";
    };

    const totalPages = Math.max(1, Math.ceil(total / limit));
    const hasFiles = files.length > 0;
    if (loading && !hasFiles) {
        return (
            <div style={{ marginTop: 'calc(50vh - 75px)' }}>
                <Loading text="Loading files in progress" />
            </div>
        );
    }
   
    return (
            <>
                <div className="segment datasets files">
                    <div className='body-segment' style={{ marginTop: "40px" }}>
                        <div className='body-segment_dataset_head'>
                            <div className='datasetnewtitle '>
                                My Files
                            </div>
                            <div className='line_head'></div>
                            <div className='betta_line'>
                                <div className='betta new'>
                                    <div className='betta_inside'>
                                        {langv?.beta?.head_text}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className={`files-upload-area ${isDrag ? "is-drag" : ""} ${hasFiles ? "has-files" : "is-empty"}`}
                            onDragOver={onDragOver}
                            onDragLeave={onDragLeave}
                            onDrop={onDrop}
                        >
                            <input
                                ref={inputRef}
                                className="files-hidden-input"
                                type="file"
                                multiple
                                onChange={onInputChange}
                            />

                            {
                                hasFiles ?
                                    
                                        
                                        <div className='header-segment dataset newlistdataset'>
                                            <div className='title_dataset_list'>
                                                <div className='left_title_dataset_list'>
                                                    <div className='add-segment-but dataset' onClick={openFileDialog}>
                                                        <svg width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M32.4226 15C32.7799 15.6188 32.7799 16.3812 32.4226 17L25.5773 28.8564C25.2201 29.4752 24.5598 29.8564 23.8453 29.8564L10.1547 29.8564C9.44017 29.8564 8.77991 29.4752 8.42265 28.8564L1.57735 17C1.22008 16.3812 1.22008 15.6188 1.57735 15L8.42265 3.14359C8.77991 2.52479 9.44017 2.14359 10.1547 2.14359L23.8453 2.14359C24.5598 2.14359 25.2201 2.52479 25.5774 3.14359L32.4226 15Z" fill="#F5C538" stroke="#F5C538"/>
                                                            <path d="M17 9V23" stroke="#020203" stroke-linecap="round"/>
                                                            <path d="M17 9V23" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                                            <path d="M17 9V23" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                                            <path d="M10 16H24" stroke="#020203" stroke-linecap="round"/>
                                                            <path d="M10 16H24" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                                            <path d="M10 16H24" stroke="black" stroke-opacity="0.2" stroke-linecap="round"/>
                                                        </svg>
                                                        Add files
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            <div className='datasethead files-datasethead'>
                                                <div className='topfield field1 file_dield_1'>
                                                    <div className='lineflex'>
                                                        <label>Name</label>
                                                    </div>
                                                    <input type="text" disabled={true} style={{ opacity: "0", height: "0" }} className="pop-input" value="" readOnly />
                                                </div>

                                                <div className='topfield field2 file_dield_2'>
                                                    <div className='lineflex'>
                                                        <label>Type</label>
                                                    </div>
                                                    <input type="text" disabled={true} style={{ opacity: "0", height: "0" }} className="pop-input" value="" readOnly />
                                                </div>

                                                <div className='topfield field3 file_dield_3'>
                                                    <div className='lineflex'>
                                                        <label>Last updates</label>
                                                    </div>
                                                    <input type="text" disabled={true} style={{ opacity: "0", height: "0" }} className="pop-input" value="" readOnly />
                                                </div>

                                                <div className='topfield field4 file_dield_4'>
                                                    <div className='lineflex'>
                                                        <label>Size</label>
                                                    </div>
                                                    <input type="text" disabled={true} style={{ opacity: "0", height: "0" }} className="pop-input" value="" readOnly />
                                                </div>

                                                <div className='topfield field5 file_dield_5'>
                                                    <div className='lineflex'>
                                                        <label>Import</label>
                                                    </div>
                                                    <input type="text" disabled={true} style={{ opacity: "0", height: "0" }} className="pop-input" value="" readOnly />
                                                </div>

                                                <div className='topfield field6 file_dield_6'>
                                                    <div className='lineflex'>
                                                        <label>Tag</label>
                                                    </div>
                                                    <input type="text" disabled={true} style={{ opacity: "0", height: "0" }} className="pop-input" value="" readOnly />
                                                </div>

                                                <div className='tolatipa_block' style={{ opacity: 0, minWidth: '36px' }}>
                                                    <svg className='arica' width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path d="M10.6875 5.41406C10.6875 5.76216 10.8258 6.096 11.0719 6.34214C11.3181 6.58828 11.6519 6.72656 12 6.72656C12.3481 6.72656 12.6819 6.58828 12.9281 6.34214C13.1742 6.096 13.3125 5.76216 13.3125 5.41406C13.3125 5.06597 13.1742 4.73213 12.9281 4.48598C12.6819 4.23984 12.3481 4.10156 12 4.10156C11.6519 4.10156 11.3181 4.23984 11.0719 4.48598C10.8258 4.73213 10.6875 5.06597 10.6875 5.41406Z" fill="black"/>
                                                    </svg>
                                                </div>
                                            </div>

                                            {files.map((file, id) => (
                                                <div className={`datasetbody ${activeId === id ? 'open' : ''}`} key={file.id}>
                                                    <div className='topfield field1 file_dield_1'>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="pop-input"
                                                            value={file.name || ""}
                                                        />
                                                    </div>

                                                    <div className='topfield field2 file_dield_2'>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="pop-input"
                                                            value={getTypeFromFile(file)}
                                                        />
                                                    </div>

                                                    <div className='topfield field3 file_dield_3'>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="pop-input"
                                                            value={formatDate(file.updatedAt || file.createdAt)}
                                                        />
                                                    </div>

                                                    <div className='topfield field4 file_dield_4'>
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="pop-input"
                                                            value={formatSize(file.size)}
                                                        />
                                                    </div>

                                                  
                                                    <div className='topfield field5 file_dield_5 f_d_5'>
                                                        
                                                        {
                                                            getStatusText(file.status) === 'Success' ?
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20.8C14.3339 20.8 16.5722 19.8729 18.2225 18.2225C19.8729 16.5722 20.8 14.3339 20.8 12C20.8 9.66609 19.8729 7.42778 18.2225 5.77746C16.5722 4.12714 14.3339 3.2 12 3.2C9.66609 3.2 7.42778 4.12714 5.77746 5.77746C4.12714 7.42778 3.2 9.66609 3.2 12C3.2 14.3339 4.12714 16.5722 5.77746 18.2225C7.42778 19.8729 9.66609 20.8 12 20.8ZM10.828 14.558L16.637 8.75L17.485 9.599L11.535 15.549C11.3475 15.7365 11.0932 15.8418 10.828 15.8418C10.5628 15.8418 10.3085 15.7365 10.121 15.549L7 12.426L7.849 11.577L10.829 14.557L10.828 14.558Z" fill="#34C759"/>
                                                                </svg>
                                                            :
                                                            getStatusText(file.status) === 'Failed' ?
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M10 5C10.1989 5 10.3897 5.0735 10.5303 5.20434C10.671 5.33518 10.75 5.51264 10.75 5.69767V11.2791C10.75 11.4641 10.671 11.6416 10.5303 11.7724C10.3897 11.9032 10.1989 11.9767 10 11.9767C9.80109 11.9767 9.61032 11.9032 9.46967 11.7724C9.32902 11.6416 9.25 11.4641 9.25 11.2791V5.69767C9.25 5.51264 9.32902 5.33518 9.46967 5.20434C9.61032 5.0735 9.80109 5 10 5ZM10 15C10.2652 15 10.5196 14.902 10.7071 14.7275C10.8946 14.5531 11 14.3165 11 14.0698C11 13.8231 10.8946 13.5864 10.7071 13.412C10.5196 13.2375 10.2652 13.1395 10 13.1395C9.73478 13.1395 9.48043 13.2375 9.29289 13.412C9.10536 13.5864 9 13.8231 9 14.0698C9 14.3165 9.10536 14.5531 9.29289 14.7275C9.48043 14.902 9.73478 15 10 15Z" fill="#FF3B30"/>
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M0 10C0 4.47721 4.47721 0 10 0C15.5228 0 20 4.47721 20 10C20 15.5228 15.5228 20 10 20C4.47721 20 0 15.5228 0 10ZM10 1.39535C7.71791 1.39535 5.52928 2.30191 3.91559 3.91559C2.30191 5.52928 1.39535 7.71791 1.39535 10C1.39535 12.2821 2.30191 14.4707 3.91559 16.0844C5.52928 17.6981 7.71791 18.6047 10 18.6047C12.2821 18.6047 14.4707 17.6981 16.0844 16.0844C17.6981 14.4707 18.6047 12.2821 18.6047 10C18.6047 7.71791 17.6981 5.52928 16.0844 3.91559C14.4707 2.30191 12.2821 1.39535 10 1.39535Z" fill="#FF3B30"/>
                                                                </svg>
                                                            :
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path opacity="0.5" d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z" fill="#D1D1D6"/>
                                                                    <path d="M20 12H22C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2V4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12Z" fill="#FFCC00"/>
                                                                </svg>
                                                        }
                                                        
                                                        <div className="tag_status">{getStatusText(file.status)}</div>
                                                    </div>

                                                    <div className='topfield field6 file_dield_6 f_d_6'>
                                                        <div className="tag_files">Raw data</div>
                                                    </div>

                                                    <div
                                                        className='tolatipa_block'
                                                        ref={activeId === id ? ref : null}
                                                        onClick={() => handleClick(id)}
                                                    >
                                                        <svg className='arica' width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M10.6875 5.41406C10.6875 5.76216 10.8258 6.096 11.0719 6.34214C11.3181 6.58828 11.6519 6.72656 12 6.72656C12.3481 6.72656 12.6819 6.58828 12.9281 6.34214C13.1742 6.096 13.3125 5.76216 13.3125 5.41406C13.3125 5.06597 13.1742 4.73213 12.9281 4.48598C12.6819 4.23984 12.3481 4.10156 12 4.10156C11.6519 4.10156 11.3181 4.23984 11.0719 4.48598C10.8258 4.73213 10.6875 5.06597 10.6875 5.41406ZM10.6875 11.9766C10.6875 12.3247 10.8258 12.6585 11.0719 12.9046C11.3181 13.1508 11.6519 13.2891 12 13.2891C12.3481 13.2891 12.6819 13.1508 12.9281 12.9046C13.1742 12.6585 13.3125 12.3247 13.3125 11.9766C13.3125 11.6285 13.1742 11.2946 12.9281 11.0485C12.6819 10.8023 12.3481 10.6641 12 10.6641C11.6519 10.6641 11.3181 10.8023 11.0719 11.0485C10.8258 11.2946 10.6875 11.6285 10.6875 11.9766ZM10.6875 18.5391C10.6875 18.8872 10.8258 19.221 11.0719 19.4671C11.3181 19.7133 11.6519 19.8516 12 19.8516C12.3481 19.8516 12.6819 19.7133 12.9281 19.4671C13.1742 19.221 13.3125 18.8872 13.3125 18.5391C13.3125 18.191 13.1742 17.8571 12.9281 17.611C12.6819 17.3648 12.3481 17.2266 12 17.2266C11.6519 17.2266 11.3181 17.3648 11.0719 17.611C10.8258 17.8571 10.6875 18.191 10.6875 18.5391Z" fill="black"/>
                                                        </svg>

                                                        <div className={`tolatipa tolatipa_delete ${activeId === id ? 'open' : ''}`} target={id}>
                                                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M6.4 2.8H9.6C9.6 2.37565 9.43143 1.96869 9.13137 1.66863C8.83131 1.36857 8.42435 1.2 8 1.2C7.57565 1.2 7.16869 1.36857 6.86863 1.66863C6.56857 1.96869 6.4 2.37565 6.4 2.8ZM5.2 2.8C5.2 2.4323 5.27242 2.0682 5.41314 1.72849C5.55385 1.38877 5.7601 1.08011 6.0201 0.820101C6.28011 0.560097 6.58878 0.35385 6.92849 0.213137C7.2682 0.0724242 7.6323 0 8 0C8.3677 0 8.7318 0.0724242 9.07151 0.213137C9.41123 0.35385 9.7199 0.560097 9.9799 0.820101C10.2399 1.08011 10.4461 1.38877 10.5869 1.72849C10.7276 2.0682 10.8 2.4323 10.8 2.8H15.4C15.5591 2.8 15.7117 2.86321 15.8243 2.97574C15.9368 3.08826 16 3.24087 16 3.4C16 3.55913 15.9368 3.71174 15.8243 3.82426C15.7117 3.93679 15.5591 4 15.4 4H14.344L13.408 13.6888C13.3362 14.4312 12.9904 15.1202 12.4381 15.6215C11.8859 16.1227 11.1666 16.4003 10.4208 16.4H5.5792C4.83349 16.4001 4.11448 16.1224 3.56236 15.6212C3.01024 15.1199 2.66459 14.431 2.5928 13.6888L1.656 4H0.6C0.44087 4 0.288258 3.93679 0.175736 3.82426C0.063214 3.71174 0 3.55913 0 3.4C0 3.24087 0.063214 3.08826 0.175736 2.97574C0.288258 2.86321 0.44087 2.8 0.6 2.8H5.2ZM6.8 6.6C6.8 6.44087 6.73679 6.28826 6.62426 6.17574C6.51174 6.06321 6.35913 6 6.2 6C6.04087 6 5.88826 6.06321 5.77574 6.17574C5.66321 6.28826 5.6 6.44087 5.6 6.6V12.6C5.6 12.7591 5.66321 12.9117 5.77574 13.0243C5.88826 13.1368 6.04087 13.2 6.2 13.2C6.35913 13.2 6.51174 13.1368 6.62426 13.0243C6.73679 12.9117 6.8 12.7591 6.8 12.6V6.6ZM9.8 6C9.95913 6 10.1117 6.06321 10.2243 6.17574C10.3368 6.28826 10.4 6.44087 10.4 6.6V12.6C10.4 12.7591 10.3368 12.9117 10.2243 13.0243C10.1117 13.1368 9.95913 13.2 9.8 13.2C9.64087 13.2 9.48826 13.1368 9.37574 13.0243C9.26321 12.9117 9.2 12.7591 9.2 12.6V6.6C9.2 6.44087 9.26321 6.28826 9.37574 6.17574C9.48826 6.06321 9.64087 6 9.8 6ZM3.7872 13.5736C3.83035 14.0189 4.0378 14.4322 4.36909 14.7329C4.70039 15.0336 5.1318 15.2001 5.5792 15.2H10.4208C10.8682 15.2001 11.2996 15.0336 11.6309 14.7329C11.9622 14.4322 12.1697 14.0189 12.2128 13.5736L13.1392 4H2.8608L3.7872 13.5736Z" fill="#FF3B30"/>
                                                            </svg>

                                                            <span
                                                                className='del_tooltip'
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setActiveId(null);
                                                                    deleteFile(file.id);
                                                                }}
                                                            >
                                                                Delete
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    
                                    :
                                    <></>
                            }

                            {
                                (!hasFiles || isDrag) ?
                                    <div className="files-drop-layer">
                                        <div className="files-upload-icon">
                                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.0009 0.000219345L7.91406 7.2011L9.53006 8.66407L14.8581 3.92113V21.5215H17.1438V3.92113L22.4695 8.66204L24.0878 7.2011L16.0009 0.000219345Z" fill="black"/>
                                                <path d="M0 29.9672V32.002H2.28571H16H29.7143H32V29.9672H0Z" fill="black"/>
                                            </svg>

                                        </div>

                                        <div className="files-drop-text">
                                            Drag file here to upload
                                        </div>

                                        {
                                            !isDrag ?
                                                <>
                                                    <div className="files-or">
                                                        or
                                                    </div>

                                                    <button className="files-add-btn" type="button" onClick={openFileDialog}>
                                                        Add files
                                                    </button>
                                                </>
                                                :
                                                <></>
                                        }
                                    </div>
                                    :
                                    <></>
                            }
                        </div>
                    </div>
                </div>

                {
                    hasFiles ?
                        <div className='pagination_line files-pagination-line'>
                            <div className='countpagepagination'>
                                Showing&nbsp;
                                {total > 0 ? (page - 1) * limit + 1 : 0}
                                &nbsp;-&nbsp;
                                {page * limit < total ? page * limit : total}
                                &nbsp;of {total} results
                            </div>

                            <div className='pagination pagdatasets'>
                                {
                                    page < 2 ?
                                        <div className='arrowP cursorenone'>
                                            <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.1">
                                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203" />
                                                    <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203" />
                                                </g>
                                            </svg>
                                        </div>
                                        :
                                        <div className='arrowP' onClick={() => loadFiles(page - 1, limit)}>
                                            <svg className='def_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203" />
                                                    <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203" />
                                                </g>
                                            </svg>

                                            <svg className='hov_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="url(#paint_files_prev)" />
                                                <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203" />
                                                <defs>
                                                    <linearGradient id="paint_files_prev" x1="1" y1="13" x2="45" y2="13" gradientUnits="userSpaceOnUse">
                                                        <stop stopColor="#F5C538" />
                                                        <stop offset="1" stopColor="#F5C538" stopOpacity="0" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                        </div>
                                }

                                <div className='pagenum'>
                                    <span>{page < 10 ? "0" + page : page}</span>
                                    /
                                    {totalPages < 10 ? "0" + totalPages : totalPages}
                                </div>

                                {
                                    page >= totalPages ?
                                        <div className='arrowP cursorenone'>
                                            <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.1">
                                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203" />
                                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203" />
                                                </g>
                                            </svg>
                                        </div>
                                        :
                                        <div className='arrowP' onClick={() => loadFiles(page + 1, limit)}>
                                            <svg className='def_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.4">
                                                    <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203" />
                                                    <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203" />
                                                </g>
                                            </svg>

                                            <svg className='hov_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="url(#paint_files_next)" />
                                                <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203" />
                                                <defs>
                                                    <linearGradient id="paint_files_next" x1="53" y1="13" x2="10" y2="13" gradientUnits="userSpaceOnUse">
                                                        <stop stopColor="#F5C538" />
                                                        <stop offset="1" stopColor="#F5C538" stopOpacity="0" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                        </div>
                                }
                            </div>
                        </div>
                        :
                        <></>
                }

                {
                    showUploadPopup ?
                        <div className="upload-popup">
                            <button
                                className="upload-popup-close"
                                type="button"
                                onClick={() => setShowUploadPopup(false)}
                            >
                                <svg width="23" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.2987 5.7107C17.9087 5.3207 17.2787 5.3207 16.8887 5.7107L11.9988 10.5907L7.10875 5.7007C6.71875 5.3107 6.08875 5.3107 5.69875 5.7007C5.30875 6.0907 5.30875 6.7207 5.69875 7.1107L10.5888 12.0007L5.69875 16.8907C5.30875 17.2807 5.30875 17.9107 5.69875 18.3007C6.08875 18.6907 6.71875 18.6907 7.10875 18.3007L11.9988 13.4107L16.8887 18.3007C17.2787 18.6907 17.9087 18.6907 18.2987 18.3007C18.6887 17.9107 18.6887 17.2807 18.2987 16.8907L13.4087 12.0007L18.2987 7.1107C18.6787 6.7307 18.6787 6.0907 18.2987 5.7107Z" fill="#0B0B0B"/>
                                </svg>

                            </button>

                            <div className="upload-popup-title">
                                Upload files
                            </div>

                            <div className="upload-popup-note">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 7C12.1989 7 12.3897 7.0735 12.5303 7.20434C12.671 7.33518 12.75 7.51264 12.75 7.69767V13.2791C12.75 13.4641 12.671 13.6416 12.5303 13.7724C12.3897 13.9032 12.1989 13.9767 12 13.9767C11.8011 13.9767 11.6103 13.9032 11.4697 13.7724C11.329 13.6416 11.25 13.4641 11.25 13.2791V7.69767C11.25 7.51264 11.329 7.33518 11.4697 7.20434C11.6103 7.0735 11.8011 7 12 7ZM12 17C12.2652 17 12.5196 16.902 12.7071 16.7275C12.8946 16.5531 13 16.3165 13 16.0698C13 15.8231 12.8946 15.5864 12.7071 15.412C12.5196 15.2375 12.2652 15.1395 12 15.1395C11.7348 15.1395 11.4804 15.2375 11.2929 15.412C11.1054 15.5864 11 15.8231 11 16.0698C11 16.3165 11.1054 16.5531 11.2929 16.7275C11.4804 16.902 11.7348 17 12 17Z" fill="#FFCC00"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47721 6.47721 2 12 2C17.5228 2 22 6.47721 22 12C22 17.5228 17.5228 22 12 22C6.47721 22 2 17.5228 2 12ZM12 3.39535C9.71791 3.39535 7.52928 4.30191 5.91559 5.91559C4.30191 7.52928 3.39535 9.71791 3.39535 12C3.39535 14.2821 4.30191 16.4707 5.91559 18.0844C7.52928 19.6981 9.71791 20.6047 12 20.6047C14.2821 20.6047 16.4707 19.6981 18.0844 18.0844C19.6981 16.4707 20.6047 14.2821 20.6047 12C20.6047 9.71791 19.6981 7.52928 18.0844 5.91559C16.4707 4.30191 14.2821 3.39535 12 3.39535Z" fill="#FFCC00"/>
                                </svg>

                                Please do not close this window until all files have been imported
                            </div>

                            <div className="upload-popup-list">
                                {
                                    uploadItems.map((item) =>
                                        <div className="upload-popup-file" key={item.localId}>
                                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.7264 15.9001C20.6156 15.9001 19.5503 15.4578 18.7649 14.6705C17.9794 13.8832 17.5382 12.8154 17.5382 11.702V6.10446H11.9539C11.2133 6.10446 10.5031 6.39933 9.97951 6.9242C9.45588 7.44907 9.1617 8.16094 9.1617 8.90322V27.0952C9.1617 27.8374 9.45588 28.5493 9.97951 29.0742C10.5031 29.5991 11.2133 29.8939 11.9539 29.8939H24.5186C25.2591 29.8939 25.9693 29.5991 26.4929 29.0742C27.0165 28.5493 27.3107 27.8374 27.3107 27.0952V15.9001H21.7264ZM18.9343 11.702C18.9343 12.4443 19.2284 13.1561 19.7521 13.681C20.2757 14.2059 20.9859 14.5007 21.7264 14.5007H26.7383L18.9343 6.6782V11.702ZM11.9539 4.70508H18.9343L28.7068 14.5007V27.0952C28.7068 28.2086 28.2655 29.2764 27.4801 30.0637C26.6946 30.851 25.6294 31.2933 24.5186 31.2933H11.9539C10.8431 31.2933 9.77778 30.851 8.99233 30.0637C8.20688 29.2764 7.76563 28.2086 7.76562 27.0952V8.90322C7.76562 7.7898 8.20688 6.72199 8.99233 5.93469C9.77778 5.14738 10.8431 4.70508 11.9539 4.70508Z" fill="#C7C7CC"/>
                                            </svg>


                                            <div className="upload-file-info">
                                                <div>{item.name}</div>
                                                <span>{formatSize(item.size)}</span>
                                            </div>
                                            
                                            {
                                                item.status === 'success' ?
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20.8C14.3339 20.8 16.5722 19.8729 18.2225 18.2225C19.8729 16.5722 20.8 14.3339 20.8 12C20.8 9.66609 19.8729 7.42778 18.2225 5.77746C16.5722 4.12714 14.3339 3.2 12 3.2C9.66609 3.2 7.42778 4.12714 5.77746 5.77746C4.12714 7.42778 3.2 9.66609 3.2 12C3.2 14.3339 4.12714 16.5722 5.77746 18.2225C7.42778 19.8729 9.66609 20.8 12 20.8ZM10.828 14.558L16.637 8.75L17.485 9.599L11.535 15.549C11.3475 15.7365 11.0932 15.8418 10.828 15.8418C10.5628 15.8418 10.3085 15.7365 10.121 15.549L7 12.426L7.849 11.577L10.829 14.557L10.828 14.558Z" fill="#34C759"/>
                                                    </svg>
                                                :
                                                item.status === 'failed' ?
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10 5C10.1989 5 10.3897 5.0735 10.5303 5.20434C10.671 5.33518 10.75 5.51264 10.75 5.69767V11.2791C10.75 11.4641 10.671 11.6416 10.5303 11.7724C10.3897 11.9032 10.1989 11.9767 10 11.9767C9.80109 11.9767 9.61032 11.9032 9.46967 11.7724C9.32902 11.6416 9.25 11.4641 9.25 11.2791V5.69767C9.25 5.51264 9.32902 5.33518 9.46967 5.20434C9.61032 5.0735 9.80109 5 10 5ZM10 15C10.2652 15 10.5196 14.902 10.7071 14.7275C10.8946 14.5531 11 14.3165 11 14.0698C11 13.8231 10.8946 13.5864 10.7071 13.412C10.5196 13.2375 10.2652 13.1395 10 13.1395C9.73478 13.1395 9.48043 13.2375 9.29289 13.412C9.10536 13.5864 9 13.8231 9 14.0698C9 14.3165 9.10536 14.5531 9.29289 14.7275C9.48043 14.902 9.73478 15 10 15Z" fill="#FF3B30"/>
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M0 10C0 4.47721 4.47721 0 10 0C15.5228 0 20 4.47721 20 10C20 15.5228 15.5228 20 10 20C4.47721 20 0 15.5228 0 10ZM10 1.39535C7.71791 1.39535 5.52928 2.30191 3.91559 3.91559C2.30191 5.52928 1.39535 7.71791 1.39535 10C1.39535 12.2821 2.30191 14.4707 3.91559 16.0844C5.52928 17.6981 7.71791 18.6047 10 18.6047C12.2821 18.6047 14.4707 17.6981 16.0844 16.0844C17.6981 14.4707 18.6047 12.2821 18.6047 10C18.6047 7.71791 17.6981 5.52928 16.0844 3.91559C14.4707 2.30191 12.2821 1.39535 10 1.39535Z" fill="#FF3B30"/>
                                                    </svg>
                                                :
                                                    <svg
                                                        className="upload-progress-circle"
                                                        width="32"
                                                        height="32"
                                                        viewBox="0 0 32 32"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <circle
                                                            className="upload-progress-circle__background"
                                                            cx="16"
                                                            cy="16"
                                                            r="13"
                                                            fill="none"
                                                            stroke="#D1D1D6"
                                                            strokeWidth="2"
                                                            opacity="0.5"
                                                        />

                                                        <circle
                                                            className="upload-progress-circle__value"
                                                            cx="16"
                                                            cy="16"
                                                            r="13"
                                                            fill="none"
                                                            stroke="#FFCC00"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeDasharray={2 * Math.PI * 13}
                                                            strokeDashoffset={
                                                                (2 * Math.PI * 13) *
                                                                (
                                                                    1 -
                                                                    Math.min(
                                                                        100,
                                                                        Math.max(0, item.progress || 0)
                                                                    ) / 100
                                                                )
                                                            }
                                                            transform="rotate(-90 16 16)"
                                                        />

                                                        <text
                                                            className="upload-progress-circle__text"
                                                            x="16"
                                                            y="16"
                                                            textAnchor="middle"
                                                            dominantBaseline="central"
                                                        >
                                                            {Math.min(
                                                                99,
                                                                Math.max(1, item.progress || 1)
                                                            )}%
                                                        </text>
                                                    </svg>
                                            }

                                        
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        :
                        <></>
                }
            </>
    );
});

export default Sidebar;